export default __webpack_public_path__ + "static/media/test_highlight.6f484d51.svg";